import styled from 'styled-components'

export const NavbarTitle = styled.span`
  font-size: 20px;
  font-family: ${(props) => props.theme.fontFamily};
`
